import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    nowPage: 0, // 当前页
    showSingleWork: false,
    singleWork: {
      id: 1,
      src: '',
      title: '',
      enTitle: '',
      details: '',
    },
    showMusic: false, // 显示音乐
    showNextBtn: true, // 显示下一个按钮
  },
  mutations: {
    setNowPage(state, nowPage) {
      state.nowPage = nowPage
      if ( !state.showMusic ) {
        state.showMusic = true
      }
    },
    changeSingleWork (state, showSingleWork) {
      state.showSingleWork = showSingleWork
    },
    setSingleWork (state, singleWork) {
      state.singleWork = singleWork
    },
    setNextBtn ( state, showNextBtn ) {
      state.showNextBtn = showNextBtn
    },
  },
  actions: {
    setNowPage({
      commit
    }, p) {
      commit('setNowPage', p)
    },
    changeSingleWork({
      commit
    }, p) {
      commit('changeSingleWork', p)
    },
    setSingleWork({
      commit
    }, p) {
      commit('setSingleWork', p)
    },
    setNextBtn({
      commit
    }, p) {
      commit('setNextBtn', p)
    },
  },
  modules: {
  }
})
